import React, { useState, useEffect, useRef, useContext } from "react";

import { useHistory, useParams } from "react-router-dom";
import { parseISO, format, isSameDay } from "date-fns";
import clsx from "clsx";

import makeStyles from "@mui/styles/makeStyles";
import { green } from "@mui/material/colors";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import { i18n } from "../../translate/i18n";
import DoneIcon from "@mui/icons-material/Done";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReplayIcon from "@mui/icons-material/Replay";
import StopIcon from "@mui/icons-material/Stop";
import api from "../../services/api";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import ButtonWithSpinner from "../ButtonWithSpinner";
import MarkdownWrapper from "../MarkdownWrapper";
import { Tooltip } from "@mui/material";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import AcceptTicketWithouSelectQueue from "../AcceptTicketWithoutQueueModal"; 

const useStyles = makeStyles(theme => ({
	ticket: {
		position: "relative",
	},

	pendingTicket: {
		cursor: "unset",
	},

	noTicketsDiv: {
		display: "flex",
		height: "100px",
		margin: 40,
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
	},

	noTicketsText: {
		textAlign: "center",
		color: "rgb(104, 121, 146)",
		fontSize: "14px",
		lineHeight: "1.4",
	},

	noTicketsTitle: {
		textAlign: "center",
		fontSize: "16px",
		fontWeight: "600",
		margin: "0px",
	},

	contactNameWrapper: {
		display: "flex",
		justifyContent: "space-between",
	},

	lastMessageTime: {
		justifySelf: "flex-end",
		paddingRight: "6%"
	},

	closedBadge: {
		alignSelf: "center",
		justifySelf: "center",
		marginRight: 42,
		paddingRight: 20,
		top: "-2px",
		marginLeft: "auto",
	},

	closedBadge: {
		alignSelf: "center",
		justifySelf: "flex-end",
		marginRight: 32,
		marginLeft: "auto",
	},

	contactLastMessage: {
		paddingRight: 20,
	},

	newMessagesCount: {
		alignSelf: "center",
		marginRight: 8,
		marginLeft: "auto",
	},

	bottomButton: {
		top: "12px",

	},
	bottomButton2: {
		top: "12px",
		paddingRight: '4%',
	},

	badgeStyle: {
		color: "white",
		backgroundColor: green[500],
	},

	acceptButton: {
		position: "absolute",
		left: "45%",
		top: "2px",
	},

	ticketQueueColor: {
		flex: "none",
		width: "8px",
		height: "100%",
		position: "absolute",
		top: "0%",
		left: "0%",
	},

	userTag: {
		position: "absolute",
		marginRight: 5,
		right: 20,
		bottom: 30,
		background: "#2576D2",
		color: "#ffffff",
		border: "1px solid #CCC",
		padding: 1,
		paddingLeft: 5,
		paddingRight: 5,
		borderRadius: 10,
		fontSize: "0.9em"
	},
	channelTag: {
		display: "inline-block",
		marginLeft: 6,
		verticalAlign: "middle",
		background: "#ecfdf5",
		color: "#0f766e",
		border: "1px solid #99f6e4",
		padding: "1px 6px",
		borderRadius: 8,
		fontSize: "0.7em",
		fontWeight: 700,
		whiteSpace: "nowrap",
	},
	channelTagInstagram: {
		background: "#fdf2f8",
		color: "#9d174d",
		border: "1px solid #fbcfe8",
	},
	channelTagWebsite: {
		background: "#eff6ff",
		color: "#1d4ed8",
		border: "1px solid #bfdbfe",
	},
}));

const TicketListItem = ({ ticket }) => {
	const classes = useStyles();
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const { ticketId } = useParams();
	const isMounted = useRef(true);
	const [acceptTicketWithouSelectQueueOpen, setAcceptTicketWithouSelectQueueOpen] = useState(false);
	const { user } = useContext(AuthContext);

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const handleAcepptTicket = async id => {
		setLoading(true);
		try {
			await api.put(`/tickets/${id}`, {
				status: "open",
				userId: user?.id,
			});
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
		if (isMounted.current) {
			setLoading(false);
		}
		history.push(`/tickets/${id}`);
	};

	const handleReopenTicket = async id => {
		setLoading(true);
		try {
			await api.put(`/tickets/${id}`, {
				status: "open",
				userId: user?.id,
			});
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
		if (isMounted.current) {
			setLoading(false);
		}
		history.push(`/tickets/${id}`);
	};

	const handleViewTicket = async id => {
		setLoading(true);
		try {
			await api.put(`/tickets/${id}`, {
				status: "pending",
			});
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
		if (isMounted.current) {
			setLoading(false);
		}
		history.push(`/tickets/${id}`);
	};	

	const handleClosedTicket = async id => {
		setLoading(true);
		try {
			await api.put(`/tickets/${id}`, {
				status: "closed",
				userId: user?.id,
			});
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
		if (isMounted.current) {
			setLoading(false);
		}
		//history.push(`/tickets/${id}`);
	};		

	
	const handleSelectTicket = id => {
		history.push(`/tickets/${id}`);
	};

	const queueName = selectedTicket => {
		let name = null;
		let color = null;
		user.queues.forEach(userQueue => {
			if (userQueue.id === selectedTicket.queueId) {
				name = userQueue.name;
				color = userQueue.color;
			}
		});
		return {
			name,
			color
		};
	}
	
	const handleOpenAcceptTicketWithouSelectQueue = () => {
		setAcceptTicketWithouSelectQueueOpen(true);
	};

	return (
		<React.Fragment key={ticket.id}>
			<AcceptTicketWithouSelectQueue
			modalOpen={acceptTicketWithouSelectQueueOpen}
			onClose={(e) => setAcceptTicketWithouSelectQueueOpen(false)}
			ticketId={ticket.id}
		/>
			<ListItem
				dense
				button
				onClick={e => {
					if (ticket.status === "pending") return;
					handleSelectTicket(ticket.id);
				}}
				selected={ticketId && +ticketId === ticket.id}
				className={clsx(classes.ticket, {
					[classes.pendingTicket]: (ticket.status === "pending"),
				})}
			>
				<Tooltip
					arrow
					placement="right"
					title={ticket.queue?.name || queueName(ticket)?.name || "Sem fila"}
				>
					<span
						style={{ backgroundColor: ticket.queue?.color || queueName(ticket)?.color || "#7C7C7C" }}
						className={classes.ticketQueueColor}
					></span>
				</Tooltip>
				<ListItemAvatar>
					<Avatar src={ticket?.contact?.profilePicUrl} />
				</ListItemAvatar>
				<ListItemText
					disableTypography
					primary={
						<span className={classes.contactNameWrapper}>
							<Typography
								noWrap
								component="span"
								variant="body2"
								color="textPrimary"
							>
								{ticket.contact.name}
							</Typography>
							{ticket.status === "closed" && (
							<Badge
								className={classes.closedBadge}
								badgeContent={"Encerrada"}
								color="primary"
							/>
						)}
							{ticket.lastMessage && (
								<Typography
									className={classes.lastMessageTime}
									component="span"
									variant="body2"
									color="textSecondary"
								>
									{isSameDay(parseISO(ticket.updatedAt), new Date()) ? (
										<>{format(parseISO(ticket.updatedAt), "HH:mm")}</>
									) : (
										<>{format(parseISO(ticket.updatedAt), "dd/MM/yyyy")}</>
									)}
								</Typography>
							)}
							{ticket.whatsappId && (
								<div className={classes.userTag}>{ticket.whatsapp?.name?.substring(0,12)}</div>
							)}
							{ticket.channel === "website" && (
								<span className={clsx(classes.channelTag, classes.channelTagWebsite)}>
									Chat Site
								</span>
							)}
							{ticket.channel === "instagram" && (
								<span className={clsx(classes.channelTag, classes.channelTagInstagram)}>
									Instagram
								</span>
							)}
						</span>
					}
					secondary={
						<span className={classes.contactNameWrapper}>
							<Typography
								className={classes.contactLastMessage}
								noWrap
								component="span"
								variant="body2"
								color="textSecondary"
							>
								{ticket.lastMessage ? (
									<MarkdownWrapper>{
										ticket.lastMessage.includes('BEGIN:VCARD')
											? "VCARD"
											: /^\[(IMAGEM|IMAGE|VIDEO|AUDIO|DOCUMENTO|DOCUMENT|FIGURA|STICKER|PTT|ARQUIVO)\]$/i.test(ticket.lastMessage.trim())
												? ticket.lastMessage.replace(/^\[|\]$/g, "").replace(/IMAGEM/i, "Imagem")
												: ticket.lastMessage
									}</MarkdownWrapper>
								) : (
									<br />
								)}
							</Typography>

							<Badge
								className={classes.newMessagesCount}
								badgeContent={ticket.unreadMessages}
								classes={{
									badge: classes.badgeStyle,
								}}
							/>
						</span>
					}
				/>

				{/* Adicionei aqui para usar o ícone na função de atender com fila obrigatória */}
				{(ticket.status === "pending" && ticket.queue !== null) && (
				<IconButton
					color="primary"
					className={classes.bottomButton}
					onClick={e => handleAcepptTicket(ticket.id)}>
					<DoneIcon />					
				</IconButton>
				)}
				
				{(ticket.status === "pending" && (ticket.queue === null || ticket.queue === undefined)) && (
					<IconButton
						color="primary"
						className={classes.bottomButton}
						onClick={e => handleOpenAcceptTicketWithouSelectQueue(ticket.id)}>
						<DoneIcon />					
					</IconButton>
				)}	
				{/* Adicionei aqui para usar o ícone na função de atender com fila obrigatória */}
				
				 {ticket.status === "pending" && (
					<IconButton
						className={classes.bottomButton}
						color="primary"
						onClick={e => handleViewTicket(ticket.id)} >
						<VisibilityIcon />
				  	</IconButton>								
				)}	
				 {//ticket.status === "pending" && (
			//		<IconButton
			//		className={classes.bottomButton}
			//		color="primary"
			//		onClick={e => handleClosedTicket(ticket.id)} >
			//		<ClearOutlinedIcon />
			//	  	</IconButton>								
			//	)
				}				
				{ticket.status === "open" && (
					<IconButton
					className={classes.bottomButton2}
					color="primary" 
					onClick={e => handleViewTicket(ticket.id)} >
					<ReplayIcon />
				  	</IconButton>	
				)}
				 {//ticket.status === "open" && (
				//	<IconButton
			//		className={classes.bottomButton}
			//		color="primary"
				//	onClick={e => handleClosedTicket(ticket.id)} >
				//	<ClearOutlinedIcon />
			//	  	</IconButton>								
			//	)
		}						
				{ticket.status === "closed" && (
					<IconButton
					className={classes.bottomButton}
					color="primary" 
					onClick={e => handleReopenTicket(ticket.id)} >
					<ReplayIcon />
				  	</IconButton>	
				)}		
				{ticket.status === "closed" && (
					<IconButton
					className={classes.bottomButton}
					color="primary" >
				  	</IconButton>	
				)}
				{/* Adicionei aqui para usar o ícone na função de atender com fila obrigatória */}

				{/* Adicionei aqui para usar o ícone na função de atender com fila obrigatória */}	
			{ }
			</ListItem>
			<Divider variant="inset" component="li" />
		</React.Fragment>
	);
};

export default TicketListItem;